import { useContext, useEffect, useState } from 'react';
import { BlofinContext, UserInfo } from '../BlofinProvider';
import Cookies from 'js-cookie';

const useAuth = () => {
  const [isLogin, setIslogin] = useState<null | boolean>(null);

  const [userInfo, setUserInfo] = useState<UserInfo | null>(null);

  const { state } = useContext(BlofinContext);

  const { userInfo: BlofinUserInfo, userViewType, isDemoTrading, userAccountType } = state;

  useEffect(() => {
    if (!Cookies.get('token')) {
      setIslogin(false);
      return;
    }

    if (BlofinUserInfo !== null && BlofinUserInfo?.uid) {
      setIslogin(true);
    }
    if (BlofinUserInfo !== null && !BlofinUserInfo?.uid) {
      setIslogin(false);
    }
    setUserInfo(BlofinUserInfo);
  }, [BlofinUserInfo]);

  return {
    userInfo,
    isLogin,
    userViewType,
    isDemoTrading,
    userAccountType,
  };
};

export { useAuth };
